import React, { useState, useEffect } from "react";
import axios from "axios";

import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Space,
  Popconfirm,
  message,
  Select,
  Row
} from "antd";

import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import swal from "sweetalert";

const { Option } = Select;

const Reseach_admin_manage = () => {
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();

  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3002/api/";
  } else {
    xURL = "https://research.rihes.cmu.ac.th/api/";
  }

  const [dataSource1, _dataSource1] = useState();

  const [pageTable, _pageTable] = useState(1);
  const [pageSizeTable, _pageSizeTable] = useState(100);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);

  const [xUser, _xUser] = useState("");
  const [xUsername, _xUsername] = useState("");
  const [xUserValue, _xUserValue] = useState("0");
  const [xUsername2, _xUsername2] = useState("");
  const [xUserValue2, _xUserValue2] = useState("0");

  const [xRole, _xRole] = useState("");
  const [xRoleValue, _xRoleValue] = useState("0");
  const [xRoleValue2, _xRoleValue2] = useState("0");

  useEffect(() => {
    const xresearch = JSON.parse(localStorage.getItem("user"));
    const user = localStorage.getItem("user");

    if (!user) {
      // ถ้าไม่มี user ให้ redirect ไปหน้า login
      window.location = "/login";
    } else {
      axios
        .post(xURL + "findlevel", {
          research_name: xresearch.firstname_TH + " " + xresearch.lastname_TH
        })
        .then(result => {
          if (result.data[0].user_level_id !== 99) {
            alert("คุณไม่มีสิทธิ์เข้าใช้งานระบบนี้");
            window.location = "/login";
          } else {
            //ค้นหา User
            axios
              .get(xURL + "research")
              .then(result => {
                //console.log(result.data);

                _xUser(result.data);
              })
              .catch(function(error) {
                // handle error
                console.log("problem here", error);
              });

            //ค้นหาสิทธิ์
            axios
              .get(xURL + "role")
              .then(result => {
                //console.log(result.data);

                _xRole(result.data);
              })
              .catch(function(error) {
                // handle error
                console.log("problem here", error);
              });

            Finddata();
          }
        })
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });
    }
  }, []);

  const Finddata = () => {
    axios
      .get(xURL + "find_user")
      .then(result => {
        Showdata(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Showdata = zdata => {
    const Tb1 = [];

    zdata.forEach((i, idx) => {
      Tb1.push({
        key: idx,
        num: parseInt(idx + 1),
        username: i.full_name,
        user_id: i.id,
        research_id: i.researcher_staff_id,
        email: i.email,
        role: "[" + i.user_level_id + "] " + i.name
      });
    });

    _dataSource1(Tb1);
  };

  const bSaveclick = () => {
    // console.log(xRoleValue, xUsername, xUserValue);

    if (!xUsername) {
      swal("บันทึก ไม่ได้!", "คีย์ ชื่อผู้ใช้ ไม่ถูกต้อง!", "warning");
    } else if (xRoleValue == 0) {
      swal("บันทึก ไม่ได้!", "คีย์ สิทธิ์การใช้งาน ไม่ถูกต้อง!", "warning");
    } else {
      axios
        .post(xURL + "insert_user", {
          full_name: xUsername,
          role: xRoleValue,
          researcher_staff_id: xUserValue
        })
        .then(result => {
          handleOk();
        })
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });
    }
  };

  const updateclick = zdata => {
    setIsModalVisible2(true);

    _xUsername2(zdata.username);
    _xUserValue2(zdata.research_id);
    _xRoleValue2(zdata.role.split("[")[1].split("]")[0]);

    form2.setFieldsValue({ edusername: zdata.username, slrole: zdata.role });
  };

  const bEditclick = () => {
    // console.log(xRoleValue2, xUsername2, xUserValue2);

    axios
      .post(xURL + "update_user", {
        full_name: xUsername2,
        role: xRoleValue2,
        researcher_staff_id: xUserValue2
      })
      .then(result => {
        handleOk2();
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const deleteclick = zdata => {
    swal({
      title: "ยืนยันลบผู้ใช้งาน",
      text: "ชื่อผู้ใช้งาน : " + zdata.username,
      icon: "warning",
      dangerMode: true,
      buttons: ["ยกเลิก", "ยืนยัน"]
    }).then(willDelete => {
      if (willDelete) {
        axios
          .post(xURL + "delete_user", {
            full_name: zdata.username,
            researcher_staff_id: zdata.research_id
          })
          .then(result => {
            swal({
              title: "แจ้งเตือน!",
              text: "ลบผู้ใช้งานสำเร็จ!",
              icon: "success",
              buttons: false,
              timer: 2000
            }).then(() => {
              Finddata();
            });
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      }
    });
  };

  const columns1 = [
    {
      title: "ลำดับ",
      dataIndex: "num",
      key: "num",
      align: "center",
      width: 50,
      sorter: (a, b) => a.num - b.num
    },
    {
      title: "ชื่อ User",
      dataIndex: "username",
      key: "username",
      align: "center",
      width: 350,
      sorter: (a, b) => {
        return a.username.localeCompare(b.username);
      }
    },
    {
      title: "User_id",
      dataIndex: "user_id",
      key: "user_id",
      align: "center",
      width: 50,
      sorter: (a, b) => a.user_id - b.user_id
    },
    {
      title: "Research_id",
      dataIndex: "research_id",
      key: "research_id",
      align: "center",
      width: 100,
      sorter: (a, b) => a.research_id - b.research_id
    },
    {
      title: "อีเมล",
      dataIndex: "email",
      key: "email",
      align: "center",
      width: 200
    },
    {
      title: "สิทธิ์",
      dataIndex: "role",
      key: "role",
      align: "center",
      width: 100,
      sorter: (a, b) => {
        return a.role.localeCompare(b.role);
      }
    },
    {
      title: "แก้ไขสิทธิ์",
      dataIndex: "update",
      key: "update",
      align: "center",
      width: 80,
      render(text, record, index) {
        return {
          children: (
            <Button
              icon={<EditOutlined />}
              size="small"
              onClick={e => {
                //console.log("corresponding email is :", record.i_sum3);
                updateclick(record);
              }}
            />
          )
        };
      }
    },
    {
      title: "ลบ",
      dataIndex: "delete",
      key: "delete",
      align: "center",
      width: 80,
      render(text, record, index) {
        return {
          children: (
            <Button
              danger
              icon={<DeleteOutlined />}
              size="small"
              onClick={e => {
                //console.log("corresponding email is :", record.i_sum3);
                deleteclick(record);
              }}
            />
          )
        };
      }
    }
  ];

  const handleOk = () => {
    setIsModalVisible(false);
    Finddata();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    Finddata();
  };

  const handleOk2 = () => {
    setIsModalVisible2(false);
    Finddata();
  };

  const handleCancel2 = () => {
    setIsModalVisible2(false);
    Finddata();
  };

  const pageOnChange = (zpage, zpageSize) => {
    _pageTable(zpage);
    _pageSizeTable(zpageSize);
  };

  function handleChange1(value) {
    _xUserValue(value);

    xUser.forEach((i, idx) => {
      if (i.id === value) {
        _xUsername(i.name + " " + i.lname);
      }
    });
  }

  function handleChange2(value) {
    _xRoleValue(value);
  }

  function handleChange3(value) {
    _xRoleValue2(value);
  }

  return (
    <div style={{ padding: 24 }}>
      <h2>Admin จัดการข้อมูลผู้ใช้</h2>
      <Button
        type="primary"
        style={{ marginBottom: 16 }}
        onClick={() => {
          form1.resetFields();

          _xUserValue(0);
          _xUsername();
          _xRoleValue(0);
          setIsModalVisible(true);
        }}
      >
        + เพิ่มผู้ใช้
      </Button>

      <Table
        bordered
        scroll={{ x: "max-content" }}
        dataSource={dataSource1}
        columns={columns1}
        size="small"
        pagination={{
          onChange: (zpage, zpageSize) => {
            pageOnChange(zpage, zpageSize);
          },
          current: pageTable,
          pageSize: pageSizeTable
        }}
      />

      <Modal
        title="เพิ่มผู้ใช้"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={1000}
      >
        <Form form={form1} initialValues={{}}>
          <Form.Item label="ชื่อผู้ใช้" name="slusername">
            <Select
              showSearch
              onChange={handleChange1}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children[0].toLowerCase().includes(input.toLowerCase())}
            >
              {xUser.length > 0
                ? xUser.map((i, idx) => {
                    return (
                      <Option value={i.id}>
                        {i.name} {i.lname}
                      </Option>
                    );
                  })
                : <Option value="0">
                    {}
                  </Option>}
            </Select>
          </Form.Item>

          <Form.Item label="สิทธิ์การใช้งาน" name="slrole">
            <Select onChange={handleChange2}>
              {xRole.length > 0
                ? xRole.map((i, idx) => {
                    return (
                      <Option value={i.id}>
                        {i.id} : {i.name}
                      </Option>
                    );
                  })
                : <Option value="0">
                    {}
                  </Option>}
            </Select>
          </Form.Item>
        </Form>

        <Row justify="center">
          <Button
            type="primary"
            style={{ marginBottom: 16 }}
            onClick={() => {
              bSaveclick();
            }}
          >
            บันทึก
          </Button>
        </Row>
      </Modal>

      <Modal
        title="แก้ไขสิทธิ์การใช้งาน"
        visible={isModalVisible2}
        onOk={handleOk2}
        onCancel={handleCancel2}
        footer={null}
        width={1000}
      >
        <Form form={form2} initialValues={{}}>
          <Form.Item label="ชื่อผู้ใช้" name="edusername">
            <Input disabled style={{ color: "black" }} />
          </Form.Item>

          <Form.Item label="สิทธิ์การใช้งาน" name="slrole">
            <Select onChange={handleChange3}>
              {xRole.length > 0
                ? xRole.map((i, idx) => {
                    return (
                      <Option value={i.id}>
                        {i.id} : {i.name}
                      </Option>
                    );
                  })
                : <Option value="0">
                    {}
                  </Option>}
            </Select>
          </Form.Item>
        </Form>

        <Row justify="center">
          <Button
            type="primary"
            style={{ marginBottom: 16 }}
            onClick={() => {
              bEditclick();
            }}
          >
            แก้ไข
          </Button>
        </Row>
      </Modal>
    </div>
  );
};

export default Reseach_admin_manage;
